export function safeAdminReturnPath(value) {
  return typeof value === 'string' && /^\/(?!\/)/.test(value) ? value : '/dashboard'
}
